import {IOfferListOffer} from "../../offer/types/IOfferListOffer";
import {getOfferCardAddress, IOfferCardAddressContext} from "../../offer/utils/get_offer_card_address";
import {getAmplitudeOfferUsp} from "./get_amplitude_offer_usp";
import {getAmplitudeViewItemEventProperties} from "./get_amplitude_view_item_event_properties";

interface IGetAmplitudeOfferListItemParams {
    addressContext: IOfferCardAddressContext;
    isUspVariant: boolean;
    offer: IOfferListOffer;
    index: number;
}

const getStatsRangeValue = (min?: number, max?: number): string | number | undefined => {
    if (min == null || min <= 0) {
        return undefined;
    }

    if (max == null || max <= 0 || min === max) {
        return min;
    }

    return `${min}-${max}`;
};

const getAmplitudeOfferListItemStatsProperties = (offer: IOfferListOffer): Record<string, string | number> => {
    const stats = offer.stats;

    if (!stats) {
        return {};
    }

    const properties: Record<string, string | number> = {};

    if (stats.ranges_price_min > 0) {
        properties.price = stats.ranges_price_min;
    }

    const variantArea = getStatsRangeValue(stats.ranges_area_min, stats.ranges_area_max);

    if (variantArea != null) {
        properties.variant_area = variantArea;
    }

    const variantRooms = getStatsRangeValue(stats.ranges_rooms_min, stats.ranges_rooms_max);

    if (variantRooms != null) {
        properties.variant_rooms = variantRooms;
    }

    return properties;
};

export const getAmplitudeOfferListItem = ({offer, index, isUspVariant, addressContext}: IGetAmplitudeOfferListItemParams) => {
    return {
        ...getAmplitudeViewItemEventProperties({
            offer: {
                id: offer.id,
                name: offer.name,
                type: offer.type,
                currency: offer.currency,
                vendor: offer.vendor,
                region: offer.region
            }
        }),
        ...getAmplitudeOfferListItemStatsProperties(offer),
        item_address: isUspVariant ? getOfferCardAddress(offer, addressContext) : null,
        usp: isUspVariant ? getAmplitudeOfferUsp(offer) : null,
        index
    } satisfies Record<string, string | string[] | number | null>;
};
import {IOfferListOffer} from "../../offer/types/IOfferListOffer";
import {getOfferCardAddress, IOfferCardAddressContext} from "../../offer/utils/get_offer_card_address";
import {getAmplitudeOfferUsp} from "./get_amplitude_offer_usp";
import {getAmplitudeViewItemEventProperties} from "./get_amplitude_view_item_event_properties";

interface IGetAmplitudeOfferListItemParams {
    addressContext: IOfferCardAddressContext;
    isUspVariant: boolean;
    offer: IOfferListOffer;
    index: number;
}

const getStatsRangeValue = (min?: number, max?: number): string | number | undefined => {
    if (min == null || min <= 0) {
        return undefined;
    }

    if (max == null || max <= 0 || min === max) {
        return min;
    }

    return `${min}-${max}`;
};

const getAmplitudeOfferListItemStatsProperties = (offer: IOfferListOffer): Record<string, string | number> => {
    const stats = offer.stats;

    if (!stats) {
        return {};
    }

    const properties: Record<string, string | number> = {};

    if (stats.ranges_price_min > 0) {
        properties.price = stats.ranges_price_min;
    }

    const variantArea = getStatsRangeValue(stats.ranges_area_min, stats.ranges_area_max);

    if (variantArea != null) {
        properties.variant_area = variantArea;
    }

    const variantRooms = getStatsRangeValue(stats.ranges_rooms_min, stats.ranges_rooms_max);

    if (variantRooms != null) {
        properties.variant_rooms = variantRooms;
    }

    return properties;
};

export const getAmplitudeOfferListItem = ({offer, index, isUspVariant, addressContext}: IGetAmplitudeOfferListItemParams) => {
    return {
        ...getAmplitudeViewItemEventProperties({
            offer: {
                id: offer.id,
                name: offer.name,
                type: offer.type,
                currency: offer.currency,
                vendor: offer.vendor,
                region: offer.region
            }
        }),
        ...getAmplitudeOfferListItemStatsProperties(offer),
        item_address: isUspVariant ? getOfferCardAddress(offer, addressContext) : null,
        usp: isUspVariant ? getAmplitudeOfferUsp(offer) : null,
        index
    } satisfies Record<string, string | string[] | number | null>;
};
